import { Platform } from 'react-native';
import {
  brand,
  designName,
  deviceName,
  DeviceType,
  deviceType,
  deviceYearClass,
  isDevice,
  manufacturer,
  modelId,
  modelName,
  osBuildFingerprint,
  osBuildId,
  osInternalBuildId,
  osName,
  osVersion,
  platformApiLevel,
  supportedCpuArchitectures,
  totalMemory,
} from 'expo-device';
import { getFreeDiskStorageAsync } from 'expo-file-system';

type DeviceInfo = {
  brand: string | null;
  designName: string | null;
  deviceName: string | null;
  deviceType: DeviceType | null;
  deviceYearClass: number | null;
  isDevice: boolean;
  manufacturer: string | null;
  modelId: any;
  modelName: string | null;
  osBuildFingerprint: string | null;
  osBuildId: string | null;
  osInternalBuildId: string | null;
  osName: string | null;
  osVersion: string | null;
  platformApiLevel: number | null;
  supportedCpuArchitectures: string[] | null;
  totalMemory: number | null;
  freeDiskStorage?: string | null;
};

const getDeviceInfoWithoutDiskStorage = (): DeviceInfo => ({
  brand,
  designName,
  deviceName,
  deviceType,
  deviceYearClass,
  isDevice,
  manufacturer,
  modelId,
  modelName,
  osBuildFingerprint,
  osBuildId,
  osInternalBuildId,
  osName,
  osVersion,
  platformApiLevel,
  supportedCpuArchitectures,
  totalMemory,
});

export const generateDeviceInfo = async (): Promise<DeviceInfo> => {
  const freeDiskStorage =
    Platform.OS !== 'web' ? await getFreeDiskStorageAsync() : null;

  return {
    ...getDeviceInfoWithoutDiskStorage(),
    freeDiskStorage: freeDiskStorage
      ? (freeDiskStorage / 1024 / 1024 / 1024).toFixed(3) + ' GB'
      : null,
  };
};
